export const ROUTES = {
    TEAM: 'TEAM',
    VIEW_TEAM: 'VIEW_TEAM',
    MAGIC_BOX: 'MAGIC_BOX',
}